import React, { useEffect, useState } from "react";
import Seo from "components/Seo";
import { useNavigate } from "react-router-dom";
import { useGetAlarm } from "hooks/morning/useGetAlarm";
import { useGetMypageInfo } from "hooks/morning/useGetMypageInfo";
import { useGetCounter } from "hooks/morning/useGetCounter";
import { AddressList } from "../../-components/AddressBook";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { ReactComponent as ArrowBack } from "assets/common/common/arrowBack.svg";

export default function MyPageAddress() {
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [alarm, setAlarm] = useState(false);
    const navigate = useNavigate();
    const responsive450 = useMediaQuery(450);
    const { data: infoData } = useGetMypageInfo();
    const { data: alarmData } = useGetAlarm();
    const { data: counterData } = useGetCounter();

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="마이페이지" />
            <div className="bg-white min-h-[100dvh] flex fixed z-[88888] inset-0 overflow-hidden">
                <div className="w-full max-w-[680px] mx-auto flex flex-col border-l border-r border-[#dddddd] responsive650:border-none">
                    <div className="relative text-[#262A34] text-[20px] text-center font-[500] py-[16px]">
                        주소록관리
                        <ArrowBack onClick={() => navigate(-1)} className="absolute top-1/2 -translate-y-1/2 left-[16px]" />
                    </div>
                    <div className="overflow-y-auto flex-1 px-[16px] py-[24px]">
                        <AddressList onSelect={() => {}} onClose={() => {}} isManage className="p-0 max-h-full" />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
